
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  Attribute,
  isDevMode,
  HostBinding,
} from '@angular/core';
import { None, Option, Some } from '@snowfrog/option';
import { IconService } from './icons.service';
import { ICONS, Icons } from './icons';

@Component({
  selector: 'i-icon[name]',
  exportAs: 'iIcon',
  standalone: true,
  imports: [CommonModule],
  template: `<ng-content></ng-content>`,
  styleUrls: ['./icons.component.scss'],
  providers: [IconService, { provide: ICONS, useValue: Icons }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconsComponent implements OnInit {

  @Input() @HostBinding('attr.role') role = 'icon';
  @HostBinding('class.i-icon') _hasBaseClass = true;

  // @Input() width = 'w-5';
  // @HostBinding('class') _width = '';
  // @Input() height = 'h-5'
  // @HostBinding('class') _height = '';


  @Input() width = 'w-6';
  _width = '';
  @Input() height = 'h-6'
  _height = '';



  private inlineBlockClass = 'inline-block';
  // private vTopClass = 'align-top';

  static ngAcceptInputType_name: string;

  private _name: Option<string> = new None();

  @Input() class = '';

  @HostBinding('class') get hostClasses() {
    const classList = [this._width, this._height, this.inlineBlockClass, this.class];
    return classList;
  }

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    @Attribute('aria-hidden') ariaHidden: string,
    private iconService: IconService
  ) {
    // If the user has not explicitly set aria-hidden, mark the icon as hidden, as this is
    // the right thing to do for the majority of icon use-cases.
    if (!ariaHidden) {
      elementRef.nativeElement.setAttribute('aria-hidden', 'true');
    }
  }

  ngOnInit() {
    this._width = this.width;
    this._height = this.height;
    if (this._name.isNone()) {
      const message = `in-icon must have an icon name, ex: <in-icon name="home"></in-icon>`;
      if (isDevMode()) {
        throw new Error(message);
      }
      console.error(message);
      return;
    }
  }

  @Input() set name(value: string) {
    this._name = new Some(value);
    this.setSvgElement(value);
  }

  private setSvgElement(name: string) {
    this.clearSvgElement();
    const svg = this.iconService.makeSvg(name);
    this.elementRef.nativeElement.appendChild(svg);
  }

  private clearSvgElement() {
    const layoutElement = this.elementRef.nativeElement;
    let childCount = layoutElement.childNodes.length;

    // Remove existing non-element child nodes and SVGs, and add the new SVG element.
    while (childCount--) {
      const child = layoutElement.childNodes[childCount];
      if (child.nodeType !== 1 || child.nodeName.toLowerCase() === 'svg') {
        child.remove();
      }
    }
  }
}

